import { render, staticRenderFns } from "./SettlementPreference.vue?vue&type=template&id=5571f125&"
import script from "./SettlementPreference.vue?vue&type=script&lang=js&"
export * from "./SettlementPreference.vue?vue&type=script&lang=js&"
import style0 from "./SettlementPreference.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports